import ReactDateRangePicker from 'components/ReactDateRangePicker/ReactDateRangePicker';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import Select from '../../../components/ReactSelectDropdown';
import { filterOption } from '../../../components/ReactSelectDropdown/ReactSelectDropdown';
import SearchWithButton from '../../../components/Search/SearchWithButton';
import { ItemStatusOptions } from '../../../modules/constants';
import {
  FilterLabel,
  InputWithLabelSection,
} from '../../../styledComponents/common';
import { FilterContainer } from '../../../styledComponents/tasks';

const TransferringRequestsFilter = ({
  publicZoneList,
  getPublicZoneList,
  officesShortList,
  getOfficesShortList,
  getTransferringRequestsList,
  selectedOrganization,
  getItemsList,
  itemsList,
  setSelectedParams,
  selectedParams,
}) => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState({
    startDate: moment().subtract(7, 'days'),
    endDate: moment(),
  });
  const [selectedStatus, setSelectedStatus] = useState({
    label: t('all_status'),
    value: null,
  });
  const [dateUpdated, setDateUpdated] = useState(false);
  const [requestNumber, setRequestNumber] = useState('');
  const [selectedFromPublicZone, setSelectedFromPublicZone] = useState({
    label: t('all_public_zones'),
    value: null,
  });
  const [selectedToPublicZone, setSelectedToPublicZone] = useState({
    label: t('all_public_zones'),
    value: null,
  });
  const [selectedFromOffice, setSelectedFromOffice] = useState({
    label: t('all_offices'),
    value: null,
  });
  const [selectedToOffice, setSelectedToOffice] = useState({
    label: t('all_offices'),
    value: null,
  });
  const [item, setItem] = useState({
    label: t('all_items'),
    value: null,
  });
  const statusOptions = ItemStatusOptions?.map(option => ({
    ...option,
    label: t(option.key),
  }));
  const [publicZoneOptions, setPublicZoneOptions] = useState([
    {
      label: t('all_public_zones'),
      value: null,
    },
  ]);
  const [officeOptions, setOfficeOptions] = useState([
    {
      label: t('all_offices'),
      value: null,
    },
  ]);
  const [itemOptions, setItemOptions] = useState([
    {
      label: t('all_items'),
      value: null,
    },
  ]);
  useEffect(() => {
    getPublicZoneList && getPublicZoneList();
    getItemsList && getItemsList();
  }, []);
  useEffect(() => {
    if (selectedFromPublicZone?.value) {
      getOfficesShortList({
        public_zone_id: selectedFromPublicZone.value,
      });
    } else getOfficesShortList();
  }, [selectedFromPublicZone]);
  useEffect(() => {
    if (officesShortList && officesShortList.length >= 1) {
      let newArr = [
        {
          label: t('all_offices'),
          value: null,
        },
      ];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);
  useEffect(() => {
    if (publicZoneList && publicZoneList.length > 0) {
      let newArr = [
        {
          label: t('all_public_zones'),
          value: null,
        },
      ];
      publicZoneList.forEach(zone => {
        newArr.push({
          label: zone.name,
          value: zone.id,
        });
      });
      setPublicZoneOptions(newArr);
    }
  }, [publicZoneList]);
  useEffect(() => {
    if (itemsList && itemsList.length > 0) {
      let newArr = [
        {
          label: t('all_items'),
          value: null,
        },
      ];
      itemsList.forEach(item => {
        newArr.push({
          label: item.name,
          value: item.id,
        });
      });
      setItemOptions(newArr);
    }
  }, [itemsList]);
  useEffect(() => {
    if (requestNumber == '') {
      selectedOrganization?.id && callGetTransferringRequestsList();
    }
  }, [
    dateUpdated,
    selectedStatus,
    selectedFromPublicZone,
    selectedToPublicZone,
    selectedFromOffice,
    selectedToOffice,
    item,
    selectedOrganization,
    requestNumber,
  ]);

  const callGetTransferringRequestsList = () => {
    const payload = {};
    selectedDate.startDate &&
      (payload.start = selectedDate.startDate.format('YYYY-MM-DD'));
    selectedDate.endDate &&
      (payload.end = selectedDate.endDate.format('YYYY-MM-DD'));
    requestNumber && (payload.request_no = requestNumber);
    selectedStatus?.value && (payload.status = selectedStatus.value);
    selectedFromPublicZone?.value &&
      (payload.from_public_zone_id = selectedFromPublicZone.value);
    selectedToPublicZone?.value &&
      (payload.to_public_zone_id = selectedToPublicZone.value);
    selectedFromOffice?.value &&
      (payload.from_office_id = selectedFromOffice.value);
    selectedToOffice?.value && (payload.to_office_id = selectedToOffice.value);
    item?.value && (payload.item_id = item.value);

    setSelectedParams(payload);

    getTransferringRequestsList(payload);
  };

  const handleDateChange = date => {
    setSelectedDate(date);
  };

  const handleClearSearch = () => {
    setRequestNumber('');
  };

  const handleStatusChange = e => {
    setSelectedStatus(e);
  };

  const handleRequestNumberChange = () => {
    callGetTransferringRequestsList();
  };

  const handleFromPublicZoneChange = e => {
    setSelectedFromPublicZone(e);
  };

  const handleToPublicZoneChange = e => {
    setSelectedToPublicZone(e);
  };

  const handleItemChange = e => {
    setItem(e);
  };

  return (
    <FilterContainer marginTop="30px">
      <SearchWithButton
        itemName=""
        label={t('request_number')}
        searchTermName={t('request_number')}
        searchInput={requestNumber}
        onInputChange={e => setRequestNumber(e.target.value)}
        handleSearch={handleRequestNumberChange}
        handleClearSearch={handleClearSearch}
        width="280px"
      />
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('from_public_zone')}</FilterLabel>
        <Select
          isSearchable={false}
          value={selectedFromPublicZone}
          options={publicZoneOptions}
          placeholder={t('select_from_public_zone')}
          onChange={handleFromPublicZoneChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>

      <InputWithLabelSection width="200px">
        <FilterLabel>{t('from_office')}</FilterLabel>
        <Select
          isSearchable={false}
          value={selectedFromOffice}
          options={officeOptions}
          placeholder={t('select_from_office')}
          onChange={e => setSelectedFromOffice(e)}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('to_public_zone')}</FilterLabel>
        <Select
          isSearchable={false}
          value={selectedToPublicZone}
          options={publicZoneOptions}
          placeholder={t('select_to_public_zone')}
          onChange={handleToPublicZoneChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('to_office')}</FilterLabel>
        <Select
          isSearchable={false}
          value={selectedToOffice}
          options={officeOptions}
          placeholder={t('select_to_office')}
          onChange={e => setSelectedToOffice(e)}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('item')}</FilterLabel>
        <Select
          isSearchable={false}
          value={item}
          options={itemOptions}
          placeholder={t('select_item')}
          onChange={handleItemChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="max-content">
        <FilterLabel>{t('date_range')}</FilterLabel>
        <ReactDateRangePicker
          startDate={selectedDate.startDate}
          startDateId="transferring-requests-start-date"
          endDate={selectedDate.endDate}
          endDateId="transferring-requests-end-date"
          onDatesChange={handleDateChange}
          dateDisplayFormat="DD/MM/YYYY"
          onDateSelect={() => setDateUpdated(!dateUpdated)}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('status')}</FilterLabel>
        <Select
          isSearchable={false}
          value={selectedStatus}
          options={statusOptions}
          placeholder={t('select_status')}
          onChange={handleStatusChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
    </FilterContainer>
  );
};

export default TransferringRequestsFilter;
